import React from 'react';
import { ChecklistQuestion } from '../../../../stores/checklistStore';
import SortableQuestionItem from './SortableQuestionItem';
import { SortableContext, verticalListSortingStrategy } from '@dnd-kit/sortable';

interface QuestionListProps {
    questions: ChecklistQuestion[];
    categoryColor?: string;
    variant?: 'default' | 'onboarding';
}

const QuestionList: React.FC<QuestionListProps> = ({ questions, variant = 'default' }) => {
    return (
        <SortableContext
            items={questions.map(q => q.id)}
            strategy={verticalListSortingStrategy}
        >
            <div className="space-y-2">
                <div className="flex flex-col gap-2">
                    {questions.map((q) => (
                        <SortableQuestionItem key={q.id} question={q} variant={variant} />
                    ))}
                </div>
            </div>
        </SortableContext>
    );
};

export default QuestionList;
